var scope_0 = require('/home/circleci/choice/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1cb0ba5a063ad7f2c7593ddb9b9e01e3.js').default;
var scope_1 = require('/home/circleci/choice/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ea29dc7d5d1a4276ee2bb5aef31f3c9.js').default;
var scope_2 = require('/home/circleci/choice/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    